import image1 from '../images/telegram.png'
import styles from './Updates.module.css'

const Updates = () => {
    return (
        <section className={styles.updates}>
            <h1>Pròxims desenvolupaments</h1>
            <div>
                <ul>
                    <li>
                        <span><img className={styles.telegram} src={image1} alt='telegram'></img> Bot Telegram per professionals i referents</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 4t trimestre 2024</div>
                    </li>
                    <li>
                        <span>📱 Aplicació Mòbil</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 1r trimestre 2025</div>
                    </li>
                    <li>
                        <span>📑 Elaboració de Plans Individuals</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 1r trimestre 2025</div>
                    </li>
                    <li>
                        <span>👷 Perfilat dels llocs de treball</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 1r trimestre 2025</div>
                    </li>
                    <li>
                        <span>🌍 Multiidioma</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 2n trimestre 2025</div>
                    </li>
                    <li>
                        <span>🚨 Alertes sobre evolució dels usuaris</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 2n trimestre 2025</div>
                    </li>
                    <li>
                        <span>🙋‍♀️ Comunicació directe amb els usuaris</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 3r trimestre 2025</div>
                    </li>
                    <li>
                        <span>📧 Enviament de correus mensuals de resum dels seguiments realitzats</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.bar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 4t trimestre 2025</div>
                    </li>
                    <li>
                        <span>🤖 Informes i resums amb IA sobre els usuaris</span>
                        <div className={styles.barcontent}>
                            <div className={styles.bar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                            <div className={styles.netbar}></div>
                        </div>
                        <div className={styles.date}>🗓️ 4t trimestre 2025</div>
                    </li>
                </ul>
            </div>
            <div className={styles.legend}>
                <span>Llegenda: </span>
                <span>🟥 Per començar</span>
                <span>🟥 Dissenyat</span>
                <span>🟨 En desenvolupament</span>
                <span>🟨 Test desenvolupament</span>
                <span>🟩 En producció</span>
                <span>🟩 Test de producció</span>
                <span>🟦 Desplegat</span>
            </div>
        </section>
  )
}

export default Updates